import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { mq, baseTransitionSecond } from 'style/variables';
import sizes from 'style/sizes';
import colors from 'style/colors';
import { ContentInner } from 'components/organisms/contentInner';
import { TextSet } from 'components/molecules/textSet';
import { Text } from 'components/atoms/text';
import Img from 'components/atoms/img';
import { JaHeading } from 'components/atoms/jaHeading';

type TopicsDetailColumnProps = {
  headline?: string;
  text: string;
};

type TopicsDetailColumnExplanationProps = {
  imgpath: string;
  imgalt: string;
  headline: string;
  text: string;
};

const Container = styled.div`
  display: block;
  position: relative;
  background-color: ${colors.gray03};
  margin-bottom: ${sizes.margin[180]};
  padding: ${sizes.margin[49]} 45px;
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[100]};
    padding: ${sizes.margin[49]} ${sizes.margin[32]};
  }

  a {
    text-decoration: underline;
    transition: opacity ${baseTransitionSecond}s ease;
    ${mq.onlypc} {
      &:hover {
        opacity: 0.5;
      }
    }
  }
`;

const Explanation = styled.div`
  display: flex;
  justify-content: space-between;

  ${mq.onlysp} {
    flex-direction: column;
  }

  ${Container} + & {
  }
  &:not(:first-of-type) {
    border-top: 1px solid ${colors.gray02};
    margin-top: ${sizes.margin[49]};
    padding-top: ${sizes.margin[49]};
    ${mq.onlysp} {
      margin-top: ${sizes.margin[32]};
      padding-top: ${sizes.margin[32]};
    }
  }
`;

const ExplanationImg = styled.div`
  ${mq.onlypc} {
    width: ${(180 / 700) * 100}%;
  }
  ${mq.onlysp} {
    margin-bottom: ${sizes.margin[17]};
  }
`;

const ExplanationText = styled.div`
  text-align: justify;
  ${mq.onlypc} {
    width: ${(480 / 700) * 100}%;
  }
  ${mq.onlysp} {
    h2 + div {
      margin-top: ${sizes.margin[17]};
    }
  }
`;

export const TopicsDetailColumn: React.FC<TopicsDetailColumnProps> = props => {
  return (
    <ContentInner size={'medium'}>
      <Container {...props}>
        {(props.headline || props.text) && (
          <TextSet noMargin={true}>
            <JaHeading size={'small'}>{props.headline}</JaHeading>
            <Text isDiv dangerouslySetInnerHTML={{ __html: props.text }} />
          </TextSet>
        )}
        {props.children}
      </Container>
    </ContentInner>
  );
};

export const TopicsDetailColumnExplanation: React.FC<TopicsDetailColumnExplanationProps> = props => {
  return (
    <Explanation {...props}>
      <ExplanationImg>
        <Img filename={props.imgpath} alt={props.imgalt}></Img>
      </ExplanationImg>
      <ExplanationText>
        <TextSet headingSize={'xsmall'} noMargin={true}>
          {props.headline && <JaHeading size={'xsmall'}>{props.headline}</JaHeading>}
          <Text isDiv dangerouslySetInnerHTML={{ __html: props.text }} />
        </TextSet>
      </ExplanationText>
    </Explanation>
  );
};
